export const neckDisabilityIndexEs = {
  promInstructions:
    "Por favor elige la opción que más se acerque a describir cómo tu dolor de cuello afecta tu situación actual.",
  questions: [
    {
      scaleStartLabel: "Sin Dolor",
      scaleEndLabel: "Peor Imaginable",
      scaleLabels: [
        "No tengo dolor en este momento",
        "El dolor es muy leve en este momento",
        "El dolor es moderado en este momento",
        "El dolor es bastante severo en este momento",
        "El dolor es muy severo en este momento",
        "El dolor es el peor imaginable en este momento",
      ],
      text: "¿Puedes describir la intensidad de tu dolor?",
    },
    {
      scaleStartLabel: "No Afectado",
      scaleEndLabel: "Muy Afectado",
      scaleLabels: [
        "Puedo cuidarme normalmente sin causar dolor adicional",
        "Puedo cuidarme normalmente, pero causa dolor adicional",
        "Es doloroso cuidarme, y soy lento y cuidadoso",
        "Necesito algo de ayuda pero manejo la mayor parte de mi cuidado personal",
        "Necesito ayuda todos los días en la mayoría de aspectos del cuidado personal",
        "No me visto. Me lavo con dificultad y me quedo en cama",
      ],
      text: "¿Puedes describir cómo tus síntomas del cuello afectan tu cuidado personal?",
    },
    {
      scaleStartLabel: "No Afectado",
      scaleEndLabel: "Muy Afectado",
      scaleLabels: [
        "Puedo levantar pesos pesados sin causar dolor adicional",
        "Puedo levantar pesos pesados, pero me da dolor adicional",
        "El dolor me impide levantar pesos pesados del suelo, pero puedo manejar si los elementos están convenientemente posicionados, ej. en una mesa",
        "El dolor me impide levantar pesos pesados, pero puedo manejar pesos ligeros si están convenientemente posicionados",
        "Solo puedo levantar pesos ligeros",
        "No puedo levantar o cargar nada en absoluto",
      ],
      text: "¿Puedes describir cómo tus síntomas del cuello afectan tu capacidad para levantar pesos?",
    },
    {
      scaleStartLabel: "No Afectado",
      scaleEndLabel: "Muy Afectado",
      scaleLabels: [
        "Puedo hacer tanto trabajo como quiera",
        "Solo puedo hacer mi trabajo usual, pero no más",
        "Puedo hacer la mayor parte de mi trabajo usual, pero no más",
        "No puedo hacer mi trabajo usual",
        "Apenas puedo hacer cualquier trabajo",
        "No puedo hacer ningún trabajo en absoluto",
      ],
      text: "¿Puedes describir cómo tus síntomas del cuello afectan tu capacidad para trabajar?",
    },
    {
      scaleStartLabel: "Sin Dolores de Cabeza",
      scaleEndLabel: "Todo el Tiempo",
      scaleLabels: [
        "No tengo dolores de cabeza en absoluto",
        "Tengo dolores de cabeza leves que vienen infrecuentemente",
        "Tengo dolores de cabeza moderados que vienen infrecuentemente",
        "Tengo dolores de cabeza moderados que vienen frecuentemente",
        "Tengo dolores de cabeza severos que vienen frecuentemente",
        "Tengo dolores de cabeza casi todo el tiempo",
      ],
      text: "¿Tus síntomas del cuello resultan en dolores de cabeza?",
    },
    {
      scaleStartLabel: "No Afectado",
      scaleEndLabel: "Muy Afectado",
      scaleLabels: [
        "Puedo concentrarme completamente sin ninguna dificultad",
        "Puedo concentrarme completamente con ligera dificultad",
        "Tengo un grado justo de dificultad para concentrarme",
        "Tengo mucha dificultad para concentrarme",
        "Tengo una gran dificultad para concentrarme",
        "No puedo concentrarme en absoluto",
      ],
      text: "¿Puedes describir cómo tus síntomas del cuello afectan tu capacidad para concentrarte?",
    },
    {
      scaleStartLabel: "No Afectado",
      scaleEndLabel: "Muy Afectado",
      scaleLabels: [
        "No tengo problemas para dormir",
        "Mi sueño está ligeramente perturbado por menos de 1 hora",
        "Mi sueño está levemente perturbado hasta 1-2 horas",
        "Mi sueño está moderadamente perturbado hasta 2-3 horas",
        "Mi sueño está muy perturbado hasta 3-5 horas",
        "Mi sueño está completamente perturbado hasta 5-7 horas",
      ],
      text: "¿Puedes describir cómo tus síntomas del cuello afectan tu capacidad para dormir?",
    },
    {
      scaleStartLabel: "No Afectado",
      scaleEndLabel: "Muy Afectado",
      scaleLabels: [
        "Puedo conducir mi automóvil sin dolor de cuello",
        "Puedo conducir todo el tiempo que quiera con ligero dolor de cuello",
        "Puedo conducir todo el tiempo que quiera con dolor moderado de cuello",
        "No puedo conducir todo el tiempo que quiera debido al dolor moderado de cuello",
        "Apenas puedo conducir debido al dolor severo de cuello",
        "No puedo conducir mi automóvil en absoluto debido al dolor de cuello",
      ],
      text: "¿Puedes describir cómo tus síntomas del cuello afectan tu capacidad para conducir?",
    },
    {
      scaleStartLabel: "No Afectado",
      scaleEndLabel: "Muy Afectado",
      scaleLabels: [
        "Puedo leer todo lo que quiera sin dolor de cuello",
        "Puedo leer todo lo que quiera con ligero dolor de cuello",
        "Puedo leer todo lo que quiera con dolor moderado de cuello",
        "No puedo leer todo lo que quiera debido al dolor moderado de cuello",
        "No puedo leer todo lo que quiera debido al dolor severo de cuello",
        "No puedo leer en absoluto",
      ],
      text: "¿Puedes describir cómo tus síntomas del cuello afectan tu capacidad para leer?",
    },
    {
      scaleStartLabel: "No Afectado",
      scaleEndLabel: "Muy Afectado",
      scaleLabels: [
        "No tengo dolor de cuello durante todas las actividades recreativas",
        "Tengo algo de dolor de cuello con todas las actividades recreativas",
        "Tengo algo de dolor de cuello con pocas actividades recreativas",
        "Tengo dolor de cuello con la mayoría de actividades recreativas",
        "Apenas puedo hacer actividades recreativas debido al dolor de cuello",
        "No puedo hacer ninguna actividad recreativa debido al dolor de cuello",
      ],
      text: "¿Puedes describir cómo tus síntomas del cuello afectan tus actividades recreativas?",
    },
  ],
};
